import { Typography } from "antd";
import DividerCustom from "components/_storybooks/DividerCustom";
import SpaceCustom from "components/_storybooks/SpaceCustom";
import TagCustom from "components/_storybooks/TagCustom";
import CustomDescriptions from "components/CustomDescriptions";
import { PAYMENT_METHOD, SHIPPING_TYPE } from "config/constants";
import { isOrderTypeCustomer } from "features/Order/helper";
import { useOrderPermissions } from "hooks/order";
import { t } from "i18next";
import { ORDER_PROMOTION_TYPE } from "pages/App/Order/conts";
import { formatCurrency } from "utils/helperFuncs";

const Bill = ({ dataInfoProductAndBill }) => {
  const {
    shippingFee,
    operationFee,
    totalServiceProduct,
    discount,
    loyaltyCashDiscount,
    subTotal,
    customerSubTotal,
    customerTotal,
    total,
    orderType,
    totalPromotionDiscountMoney,
    shippingType,
    shippingConfiguration,
    shippingStatus,
    customerShippingFee,
    customerTotalServiceProduct,
    sellerProfitAmount,
    usedPoint,
    depositInfo,
    promotionType,
    paymentMethod,
  } = dataInfoProductAndBill;

  const { canPromotionOrderView } = useOrderPermissions();

  const renderShippingFee = () => {
    if (
      (shippingType === SHIPPING_TYPE.DELIVER_3PARTY || shippingType === SHIPPING_TYPE.DELIVER_3PARTY_INSTANT) &&
      shippingConfiguration?.deliver3PartyConfig?.provider === null &&
      shippingFee === 0 &&
      shippingStatus !== "WAITING" &&
      shippingStatus !== "CONFIRM_PICKED"
    ) {
      if (
        shippingConfiguration?.deliver3PartyConfig?.carrierMinFee ===
        shippingConfiguration?.deliver3PartyConfig?.carrierMaxFee
      ) {
        return `${formatCurrency(shippingConfiguration?.deliver3PartyConfig?.carrierMinFee)}`;
      } else {
        return `${formatCurrency(shippingConfiguration?.deliver3PartyConfig?.carrierMinFee)} - ${formatCurrency(
          shippingConfiguration?.deliver3PartyConfig?.carrierMaxFee
        )}`;
      }
    } else {
      return formatCurrency(shippingFee);
    }
  };

  const promotionDiscountMoney = (canPromotionOrderView ? 0 : totalPromotionDiscountMoney) || 0;

  const isCustomerOrder = isOrderTypeCustomer(orderType);
  const contentMappingBill = [
    {
      label: t("order.orderDetail.totalAmountAgent"),
      value: formatCurrency(subTotal + promotionDiscountMoney),
    },
    {
      label: t("order.orderDetail.totalAmountClient"),
      value: formatCurrency(customerSubTotal),
      isHidden: !isCustomerOrder,
    },
    {
      label: t("order.orderDetail.saleOff"),
      value: formatCurrency(discount),
    },
    {
      label: t("order.orderDetail.shippingFee"),
      value: <Typography style={{ color: "#D2434D" }}>{renderShippingFee()}</Typography>,
    },
    {
      label: t("order.orderDetail.operationFee"),
      value: <Typography style={{ color: "#D2434D" }}>{formatCurrency(operationFee)}</Typography>,
      isHidden: orderType === "CUSTOMER",
    },
    {
      label: t("order.orderDetail.serviceFee"),
      value: <Typography style={{ color: "#D2434D" }}>{formatCurrency(totalServiceProduct)}</Typography>,
    },
    {
      label: "Giảm giá khi chọn Chuyển khoản/Tiền mặt ngay",
      value: (
        <Typography style={{ color: "#D2434D" }}>
          {formatCurrency(paymentMethod === PAYMENT_METHOD.Cash ? loyaltyCashDiscount || 0 : 0)}
        </Typography>
      ),
      isHidden: orderType === "CUSTOMER",
    },
    // {
    //   label: (
    //     <Typography.Text style={{ fontSize: 12, color: "#ff3333ff" }}>
    //       Tiết kiệm khi thanh toán chuyển khoản hoặc tiền mặt ngay
    //     </Typography.Text>
    //   ),
    //   value: (
    //     <Button
    //       type="link"
    //       size="small"
    //       style={{ paddingRight: 0 }}
    //       disabled={
    //         loadingApplyCashPaymentMethod || !isCanChangePaymentMethod || paymentMethod === PAYMENT_METHOD.Cash
    //       }
    //       onClick={onApplyCashPaymentMethod}
    //     >
    //       Áp dụng
    //     </Button>
    //   ),
    //   isHidden: orderType === "CUSTOMER",
    // },
    // {
    //   label: t("common.campaign"),
    //   value: formatCurrency(promotionDiscountMoney),
    //   isHidden: canPromotionOrderView,
    // },
    {
      label: "Tổng thanh toán trước khi dùng HAP",
      value: (
        <Typography style={{ color: "#0099FF", fontWeight: 600 }}>
          {formatCurrency(total + 1000 * usedPoint)}
        </Typography>
      ),
    },
    {
      label: "Dùng HAP để thanh toán",
      value: <Typography style={{ color: "#D2434D" }}>{formatCurrency(1000 * usedPoint)}</Typography>,
    },
    {
      label: (
        <Typography style={{ color: "#2246DC", fontWeight: 600 }} strong>
          {t("order.orderDetail.totalPaymentAgent")}
        </Typography>
      ),
      value: (
        <Typography style={{ color: "#2246DC", fontWeight: 600 }} strong>
          {formatCurrency(total)}
        </Typography>
      ),
    },
    {
      label: "Tiền đặt cọc",
      value: formatCurrency(depositInfo?.totalDeposit),
      isHidden: promotionType !== ORDER_PROMOTION_TYPE.PRE_ORDER_POLICY,
    },
    {
      label: "Tổng thanh toán Khách trừ cọc",
      value: formatCurrency(depositInfo?.totalPaymentAfterDeposit),
      isHidden: promotionType !== ORDER_PROMOTION_TYPE.PRE_ORDER_POLICY,
    },
    // {
    //   label: t("order.orderDetail.shippingFee"),
    //   value: renderShippingFee(),
    // },
    // {
    //   label: t("order.orderDetail.serviceFee"),
    //   value: formatCurrency(totalServiceProduct),
    // },
    // {
    //   label: <Typography.Link strong>{t("order.orderDetail.totalPaymentAgent")}</Typography.Link>,
    //   value: <Typography.Link strong>{formatCurrency(total)}</Typography.Link>,
    // },
    // {
    //   label: t("cart.debtPaymentAgent"),
    //   value: formatCurrency(total),
    // },
  ]?.filter((item) => !item?.isHidden);

  return (
    <SpaceCustom gap={12} style={{ background: "#F7F8FB", borderRadius: "8px", padding: "12px" }}>
      {orderType !== "CUSTOMER" ? (
        <CustomDescriptions
          bordered={false}
          colon={false}
          labelWidth={"60%"}
          contentWidth={"40%"}
          labelStyle={{
            fontWeight: "normal",
          }}
          contentStyle={{
            justifyContent: "flex-end",
          }}
          paddingView="0 10px 0 10px"
          title={<DividerCustom fontWeight="bold" children={t("order.orderDetail.bill")} margin={0} />}
          contentMapping={contentMappingBill}
        />
      ) : (
        <>
          <DividerCustom fontWeight="bold" children={"Hóa đơn"} margin={0} />
          <CustomDescriptions
            loading={false}
            bordered={false}
            colon={false}
            labelWidth={"50%"}
            contentWidth={"50%"}
            labelStyle={{
              fontWeight: "normal",
            }}
            contentStyle={{
              justifyContent: "flex-end",
            }}
            paddingView="0 10px 0 10px"
            title={<Typography.Text style={{ fontSize: 14 }}>Hóa đơn cho khách của đại lý</Typography.Text>}
            contentMapping={[
              {
                label: "Tổng tạm tính khách hàng",
                value: formatCurrency(customerSubTotal),
              },
              {
                label: "Phí vận chuyển",
                value: formatCurrency(customerShippingFee),
              },
              {
                label: "Phí dịch vụ",
                value: formatCurrency(customerTotalServiceProduct),
              },
              {
                label: <Typography.Link strong>Tổng thanh toán của khách</Typography.Link>,
                value: <Typography.Link strong>{formatCurrency(customerTotal)}</Typography.Link>,
              },
              {
                label: "Tiền đặt cọc",
                value: formatCurrency(depositInfo?.totalDeposit),
                isHidden: promotionType !== ORDER_PROMOTION_TYPE.PRE_ORDER_POLICY,
              },
              {
                label: "Tổng thanh toán Khách trừ cọc",
                value: formatCurrency(depositInfo?.totalPaymentAfterDeposit),
                isHidden: promotionType !== ORDER_PROMOTION_TYPE.PRE_ORDER_POLICY,
              },
            ]?.filter((item) => !item?.isHidden)}
          />
          <DividerCustom dashed margin={0} borderTopColor="#D8DFEA" />
          <CustomDescriptions
            loading={false}
            bordered={false}
            colon={false}
            labelWidth={"50%"}
            contentWidth={"50%"}
            labelStyle={{
              fontWeight: "normal",
            }}
            contentStyle={{
              justifyContent: "flex-end",
            }}
            paddingView="0 10px 0 10px"
            title={<Typography.Text style={{ fontSize: 14 }}>Hóa đơn cho đại lý</Typography.Text>}
            contentMapping={[
              {
                label: "Doanh thu bán hàng",
                value: formatCurrency(customerSubTotal),
              },
              {
                label: "Tổng thành tiền đại lý",
                value: formatCurrency(subTotal),
              },
              {
                label: "Giảm giá đơn hàng",
                value: formatCurrency(discount),
              },
              {
                label: "Lợi nhuận trước chi phí",
                value: (
                  <Typography.Text strong style={{ color: "#0099FF" }}>
                    {formatCurrency(customerSubTotal - (subTotal - discount))}
                  </Typography.Text>
                ),
              },
              {
                label: "Phí vận chuyển",
                value: formatCurrency(shippingFee),
              },
              {
                label: "Phí dịch vụ",
                value: formatCurrency(totalServiceProduct),
              },
              {
                label: <Typography.Link strong>Lợi nhuận của đại lý</Typography.Link>,
                value: (
                  <TagCustom color="#E9F9E9" style={{ color: "#0EAB10", margin: 0 }}>
                    {formatCurrency(sellerProfitAmount)}
                  </TagCustom>
                ),
              },
            ]}
          />
        </>
      )}
    </SpaceCustom>
  );
};

export default Bill;
